import React from 'react';
import { Col, ProgressBar, Row } from 'react-bootstrap';
import { formatCurrencyByLocale } from '@renenet/shared/src/utils/currencyUtils';

function FireMetrics({ projection, currencyInfo }) {
  const { fireNumber, yearsToFire, retirementAge, progressPercent } = projection;
  const { locale, aggregationCurrency } = currencyInfo;

  return (
    <div className="mb-4">
      <Row className="mb-3">
        <Col md={3}>
          <div className="text-muted small">FIRE Number</div>
          <div className="h4">{formatCurrencyByLocale(locale, aggregationCurrency, fireNumber)}</div>
        </Col>
        <Col md={3}>
          <div className="text-muted small">Years to FIRE</div>
          <div className="h4">{yearsToFire !== null ? yearsToFire : '50+'}</div>
        </Col>
        <Col md={3}>
          <div className="text-muted small">Projected Retirement Age</div>
          <div className="h4">{retirementAge !== null ? retirementAge : '—'}</div>
        </Col>
        <Col md={3}>
          <div className="text-muted small">Progress</div>
          <div className="h4">{progressPercent}%</div>
        </Col>
      </Row>
      <Row>
        <Col>
          <ProgressBar
            now={progressPercent}
            label={`${progressPercent}%`}
            variant={progressPercent >= 100 ? 'success' : 'info'}
          />
        </Col>
      </Row>
    </div>
  );
}

export default FireMetrics;
